import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { Evaluation, EvaluationStatus } from '../../../commonTypes/evaluation/calculate.types';
import { RootState } from '../../../store';
import { EvaluationFilterDto, UserDto } from '../../../commonTypes/user.types';

export const useHttpGetAllEvaluationsOnMount = (refresh: number, filter: EvaluationFilterDto) => {
    const user = useSelector<RootState, UserDto>(state => state.auth.value);
    const isAdminOwner = user.role.name === 'ADMIN' || user.role.name === 'OWNER';

    const userApi = useContainer(UserApi);

    const [evaluations, setEvaluations] = useState<Evaluation[]>([]);
    const [isReady, setIsReady] = useState(false);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        const getAllEvaluations = userApi.getAllEvaluations({
            query: {
                status: filter.status as EvaluationStatus,
                sortBy: filter.sortBy,
                page: filter.page,
                pageSize: filter.pageSize,
                sortDirection: filter.sortDirection,
            },
            onSuccess: res => {
                setEvaluations(res.body.data);
                setTotal(res.body.total);
            },
            onFinally: () => setIsReady(true),
        });

        getAllEvaluations.exec();

        return () => {
            getAllEvaluations.abort();
            setIsReady(false);
        };
    }, [userApi, isAdminOwner, refresh, filter]);

    return { evaluations, total, isReady };
};

export default useHttpGetAllEvaluationsOnMount;
